import {Web3ReactHooks} from "@web3-react/core/dist/hooks";
import {Connector} from '@web3-react/types'
import {useCallback, useEffect, useMemo, useState} from "react";
import { IWallet, project, WALLETS } from "../contract/config";
import useRedux from "./useRedux";

type IWalletTools = {
    hooks: Web3ReactHooks
    connector: Connector
}
export function useWalletTools(wallet?: IWallet | null) {
    const {reduxGetter, storeData, dispatch} = useRedux();
    const walletInfo = wallet || reduxGetter.walletInfo;
    const { useChainId, useAccounts, useIsActivating, useIsActive, useProvider, useENSNames } =  walletInfo?.hooks || WALLETS.metamask.hooks;
    const [loginStatus, setLoginStatus] = useState(false);
    const [connectStatus, setConnectStatus] = useState(false);

    const chainId = useChainId();
    const accounts = useAccounts();
    const isActivating = useIsActivating();
    const isActive = useIsActive();
    const provider = useProvider();
    const ENSNames = useENSNames(provider);

    const connector = useMemo(() => {
        return walletInfo?.connector || WALLETS.metamask.connector;
    }, [walletInfo]);


    function handleAccountsChanged(accounts:string[]) {
        if (accounts.length === 0) {
            setLoginStatus(false);
        }
    }

    useEffect(() => {
        // @ts-ignore
        if (provider && provider.provider.on) {
            // @ts-ignore
            provider.provider.on('accountsChanged',  handleAccountsChanged);
        }

        return () => {
            // @ts-ignore
            if (provider && provider.provider.on) {
                // @ts-ignore
                provider.provider.removeListener('accountsChanged', handleAccountsChanged);
            }
        }
    }, [provider]);
    useEffect(() => {
        if (accounts && accounts.length > 0) {
            const address = accounts[0];
            dispatch.setWalletAddress(address);
            dispatch.setWallet(storeData.wallet_info);
            setLoginStatus(true);
        }
    }, [accounts]);

    const activate = useCallback(() => {
        connector.activate();
    }, [connector]);

    const deactivate = useCallback(() => {
        if (connector?.deactivate) {
            connector.deactivate()
        } else {
            connector.resetState()
        }
    }, [connector]);

    const getWalletPlugin = useCallback((pluginkey: string | undefined) => {
        let pluginInfo = null;
        if (!pluginkey) {
            return null;
        }
        if (window.ethereum && window.ethereum[pluginkey]) {
            pluginInfo = window.ethereum;
        }
        // @ts-ignore
        if (window[pluginkey] && window[pluginkey].ethereum) {
            // @ts-ignore
            pluginInfo = window[pluginkey].ethereum;
        }
        if (window.ethereum && window.ethereum.providers) {
            window.ethereum.providers.some((item: any) => {
                if (!!item[pluginkey]) {
                    pluginInfo = item;
                    return true;
                }
                return false;
            });
        }
        return pluginInfo;
    }, []);

    const validWalletPlugin = useCallback((pluginkey: string) => {
        if (!pluginkey) {
            return true;
        }
        return !!getWalletPlugin(pluginkey);
        /*if (window.ethereum && window.ethereum[pluginkey]) {
            return true;
        }
        if (window.ethereum && window.ethereum.providers) {
            return window.ethereum.providers.some((item: any) => {
                return !!item[pluginkey];
            });
        }
        return false;*/
    }, []);

    const connectWallet  = useCallback(() => {
        if (connector) {
            // connector.activate();
            setConnectStatus(true);
            connector.activate(project.chainid).catch((error: any) => {
                let currentProvider = window.ethereum;
                if ((error.code === 4902) && currentProvider) {
                    const chainId = `0x${project.chainid.toString(16)}`;
                    currentProvider.request?.({
                        method: 'wallet_addEthereumChain',
                        params: [
                            {
                                chainId: chainId,
                                chainName: project.chainName,
                                nativeCurrency: {
                                    name: project.chainSymbol,
                                    symbol: project.chainSymbol,
                                    decimals: project.chainSymbolDecimals,
                                },
                                rpcUrls: [project.node],
                                blockExplorerUrls: [project.browser],
                            },
                        ],
                    }).then(() => {
                        connector.activate(project.chainid)
                    }).catch((error: any) => {
                        console.log(error)
                    }).finally(() => {
                        setConnectStatus(false);
                    })
                }
            }).then(() => {
                setConnectStatus(false);
            });
        }
    }, [connector]);

    const disconnect = useCallback(() => {
        deactivate();
        dispatch.setWalletAddress("");
        dispatch.setWallet(null);
    }, []);

    return {
        connector,
        chainId,
        accounts,
        isActivating,
        isActive,
        provider,
        ENSNames,
        activate,
        deactivate,
        validWalletPlugin,
        getWalletPlugin,
        loginStatus,
        connectStatus,
        connectWallet,
        disconnect
    }
}
